/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { CertRosetteAltIcon16Light } from './CertRosetteAltIcon16Light';
import { CertRosetteAltIcon16Regular } from './CertRosetteAltIcon16Regular';
import { CertRosetteAltIcon16Solid } from './CertRosetteAltIcon16Solid';
import { CertRosetteAltIcon20Light } from './CertRosetteAltIcon20Light';
import { CertRosetteAltIcon20Regular } from './CertRosetteAltIcon20Regular';
import { CertRosetteAltIcon20Solid } from './CertRosetteAltIcon20Solid';
import { CertRosetteAltIcon24Regular } from './CertRosetteAltIcon24Regular';
import { CertRosetteAltIcon24Solid } from './CertRosetteAltIcon24Solid';
import { CertRosetteAltIcon32Regular } from './CertRosetteAltIcon32Regular';
import { CertRosetteAltIcon64Regular } from './CertRosetteAltIcon64Regular';
var sizes = {
    16: {
        light: CertRosetteAltIcon16Light,
        regular: CertRosetteAltIcon16Regular,
        solid: CertRosetteAltIcon16Solid,
    },
    20: {
        light: CertRosetteAltIcon20Light,
        regular: CertRosetteAltIcon20Regular,
        solid: CertRosetteAltIcon20Solid,
    },
    24: {
        regular: CertRosetteAltIcon24Regular,
        solid: CertRosetteAltIcon24Solid,
    },
    32: {
        regular: CertRosetteAltIcon32Regular,
    },
    64: {
        regular: CertRosetteAltIcon64Regular,
    },
};
export var CertRosetteAltIcon = forwardRef('CertRosetteAltIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
